// extracted by mini-css-extract-plugin
export var layoutContainer = "_45-0";
export var layoutContainerNoRounding = "_45-6";
export var layoutContainerOpen = "_45-5";
export var layoutContainerResizing = "_45-1";
export var mainContent = "_45-2";
export var resizeDivider = "_45-3";
export var slidePanel = "_45-4";